<template>
  <svg
    class="custom-icon"
    width="38"
    height="38"
    viewBox="0 0 38 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.51352 18.0243C5.9918 16.1192 9.87452 14.5291 13.5023 12.931C19.7436 10.3133 26.0097 7.74095 32.339 5.34615C33.5704 4.9381 35.783 4.53904 36 6.3537C35.8812 8.92233 35.3925 11.4759 35.0573 14.0295C34.2064 19.6451 33.223 25.2414 32.2641 30.8385C31.9337 32.7028 29.5849 33.668 28.0821 32.4749C24.4704 30.049 20.8309 27.6468 17.2653 25.1647C16.0973 23.9846 17.1804 22.2899 18.2235 21.4472C21.1982 18.5321 24.353 16.0555 27.1722 12.9898C27.9327 11.1636 25.6857 12.7027 24.9446 13.1742C20.8722 15.9647 16.8994 18.9256 12.6059 21.3781C10.4127 22.5786 7.85654 21.5527 5.66438 20.8828C3.69882 20.0736 0.818551 19.2583 2.51332 18.0245L2.51352 18.0243Z"
    />
  </svg>
</template>
